import React, {Component} from "react"
import Responsive from "react-responsive"
import {Link} from "react-router-dom"
import {Checkbox, Col, Form, FormField, Row, Table} from "elemental-react16"
import {Button, Icon, Message} from "semantic-ui-react"
import {withRouter} from "react-router"
import "style/CheckoutPage.scss"
import Price from "components/Price/Price"
import HeaderCheckout from "pages/checkout/HeaderCheckout"
import shop from "shop/shop"
import ProductTable from "components/Product/ProductTable"
import track from "shop/track"
import FooterCheckout from "pages/checkout/FooterCheckout"
import ProductImageDownloader from "util/ProductImageDownloader"

@withRouter
class ConfirmationPage extends Component {
	constructor() {
		super()
		this.state = {
			show   : false,
			cart   : shop.cart,
			agb    : false,
			privacy: false,
			fracht: false
		}
		shop.cart.hooks.changed.add( this.update )
	}

	update = ( cart ) => {
		this.setState( {cart} )
	}

	updateCart = () => {
		let products = getProducts()
		products = getProducts()
		this.setState( { products } )
		this.forceUpdate()
	  }

	componentDidMount() {
		shop.cart.hydrate()
		shop.cart.hooks.changed.add( this.updateCart )
		track.checkout( {step: 3, products: shop.cart.products} )
		shop.cart.update()
	}

	componentWillUnmount() {
		shop.cart.hooks.changed.remove( this.update )
	}

	toHome = () => {
		this.props.history.push( "/home" )
	}

	render() {
		let {agb, privacy,fracht} = this.state
		let manual_order_id = shop.cart.getExtra( "manual_order_id" )
		let referenceId = shop.cart.getExtra( "referenceId" )
		let attachments = shop.cart.getExtra( "attachments" )
		console.log("manualorderid",shop.cart.data)
		let {comment, deliveraddress, deliverdate} = shop.cart.data
		let billingAddress = shop.session.value
		const {checkoutType} = this.props.match.params
		const isRequest = !!checkoutType
		const {hasDeliveryAddress} = shop.cart
		const tax = shop.cart.sum / 100 * Number( shop.config.taxRate )
		const hasTax = shop.config.taxRate
		console.log("deliveraddress: ",deliveraddress)
		if(!shop.session.value) return <div className="pa4 tc">HTTP 404</div>
		
		return (
			<div className="pb4">
				<HeaderCheckout activeStep={2} />
				
				<div className="container ">
					{/*<Link to="/checkout/delivery"> <Button > <i className="icon-angle-left"/> Zurück </Button></Link>*/}
					<section>

						<Table className="tableConfirmationEdit ba b--white" compact>
							<colgroup>
							</colgroup>
							<tbody>
								<tr>
									<td className="tl">
										<h2>{translate( "Bestellung" )}</h2>
									</td>
									<td className="tr"><Link to={{
										pathname: "../../checkout/delivery",
										search  : this.props.location.search
										}}>
										<Button  style={{borderRadius: "35px", height: "40px", width: "120px", backgroundColor: "#E3E0CA"}}><span className="fw7 black">{translate("Bearbeiten")}</span></Button>
										</Link>
									</td>
								</tr>
							</tbody>
						</Table>
												<Responsive maxWidth={789}>
									<table>
										<colgroup>
											<col width="70%"/>
											<col width="50%"/>
										</colgroup>
						
									  <tbody>
										<tr>
										  <td className="bb b--black-20 pb2 v-top">
										  <span className="black-50">{translate( "Rechnungsadresse" )} </span>
										  <div className="pt3">
										<strong> {billingAddress.title}</strong> <br/>
										{billingAddress.street} <br/>
										{billingAddress.pcode} {billingAddress.city}<br/>
										{/*{billingAddress.country}<br/> */}
										{billingAddress.email && <div>{billingAddress.email}</div>}
										{billingAddress.phone && <div>{billingAddress.phone}</div>}
										{/*billingAddress.extras && billingAddress.extras.bemerkung && billingAddress.extras.bemerkung != "" && <div>{billingAddress.extras.bemerkung}</div>*/}
									  </div>
											</td>
										  <td className="bb b--black-20 pb2 v-top">
										  <span className="black-50">{translate( "Lieferadresse" )} </span>
										  <div className="pt3">
															{!hasDeliveryAddress && <div className={"b"}>{translate( "Rechnungsadresse" )}</div>}
															{deliveraddress && <div>
															<div className="mb4">
																<strong>{deliveraddress.name1} {deliveraddress.name2} {deliveraddress.name3}</strong><br/>
																{deliveraddress.street}<br/>
																{deliveraddress.pcode} {deliveraddress.city}<br/>
																{/*{deliveraddress.country}<br/> */}
																<div className="pt3 f6">
																{deliveraddress.email && <div>{deliveraddress.email}</div>}
																{deliveraddress.phone && <div>Tel.: {deliveraddress.phone}</div>}
																{/*deliveraddress.extras && deliveraddress.extras.bemerkung && deliveraddress.extras.bemerkung != '' && <div>Bemerkung: {htmr(deliveraddress.extras.bemerkung)}</div> */}
																</div>
															</div>
															</div>}
														</div>
											</td>
										</tr>
										<tr>
											<td className="pl2 pt3">
											<span className="black-50">{translate("your comment")}</span>
											</td>
										</tr>
										<tr>
										  <td className="pl2 pt3 pb3 bb b--black-20 v-top">
										  <strong>{comment ? comment : "-"}</strong>
										  </td>
										</tr>
										</tbody>
									</table>
									</Responsive>
									<Responsive minWidth={790}>
						<div className="pb3">
							<Row>
								{(manual_order_id !== undefined) &&
								<Col md="1/5" className=""><span className="black-50">{translate( "manual_order_id" )}</span>
									<div className="pt3">
										<p className="mb4">{manual_order_id}</p>
									</div>
								</Col>}
								{(referenceId !== undefined) &&
								<Col md="1/5" className=""><span className="black-50">{translate( "Referenznummer" )}</span>
									<div className="pt3">
										<p className="mb4">{referenceId}</p>
									</div>
								</Col>}
								<Col md="1/3" className=""><span className="black-50">{translate( "Rechnungsadresse" )} </span>
									<div className="pt3">
										<strong> {billingAddress.title}</strong> <br />
										{billingAddress.street} <br />
										{billingAddress.pcode} {billingAddress.city}<br />
										{/*{billingAddress.country}<br /> */}
									</div>
								</Col>
								<Col md="1/3" className=""><span className="black-50">{translate( "Lieferadresse" )} </span>
									<div className="pt3">
										{!hasDeliveryAddress && <div className={"b"}>{translate( "Lieferadresse entspricht der Rechnungsadresse" )}</div>}
										{deliveraddress && <div className="mb4">
											<strong>{deliveraddress.name1} {deliveraddress.name2} {deliveraddress.name3}</strong><br />
											{deliveraddress.street}<br />
											{deliveraddress.pcode} {deliveraddress.city}<br />
											{/*{deliveraddress.country}<br /> */}
										</div>
										}
									</div>
								</Col>
								<Col md="1/3" className=""><span className="black-50">{translate( "payment" )}</span>
									<div className="pt3">
										<strong>{translate( "Nach Vereinbarung" )}</strong>
									</div>
								</Col>
								{/*<Col md="1/5" className=""><span className="black-50">{translate( "your comment" )}
									<div className="pt3">
                  <p className="mb4">{comment ? comment : "-"}</p>
              </div>
              </span></Col>*/}
								{deliverdate &&
								<Col md="1/5" className=""><span className="black-50">{translate( "delivery after" )}
									<div className="pt3">
                  <p className="mb4">{deliverdate}</p>
              </div>
              </span></Col>}
							</Row>
						</div>
						</Responsive>
					</section>

					<section>

						{attachments && <Row>
							<Col>
								<div className="row-title tl">
									<h2>{translate( "attachments" )}</h2>
								</div>
								<p><strong>Logo ID</strong>: {attachments}</p>
							</Col>
						</Row>}
					</section>


					<section className="overflow-hidden pt3">


						<Table className="tableConfirmationEdit ba b--white" compact>
							<colgroup>
							</colgroup>
							<tbody>
								<tr>
									<td className="tl">
										<h2>{translate( "Bestellung" )}</h2>
									</td>
									<td className="tr"><Link to={{
										pathname: "../../checkout",
										search  : this.props.location.search
										}}>
										<Button  style={{borderRadius: "35px", height: "40px", width: "120px", backgroundColor: "#E3E0CA"}}><span className="fw7 black">{translate("Bearbeiten")}</span></Button>
										</Link>
									</td>
								</tr>
							</tbody>
						</Table>

						<ProductTable readOnly={true} cart={shop.cart} onChange={this.handleChange} products={getProducts()} />
						{shop.cart.sum <= shop.config.MIN_ORDER_VALUE &&
											<div className="cf pb2">
												<Message negative className="">
													<div className="total ">
														<div className="ph3">
															<Icon name="info" />{translate( "minimum order value not reached" )}
															<span className="pull-right">
																<Price>{shop.config.MIN_ORDER_VALUE}</Price>
														 </span>
														</div>
													</div>
													
												</Message>
											</div>
											}

						<Table style={{maxWidth: "320px"}} className="fr">
							<thead>

							{/*							<tr>
								<td className="tr" colSpan="2">
									<span className="black-50 f5"><strong>{shop.cart.size} {translate( "positions" )} </strong></span>
								</td>
							</tr>

							<tr>
								<td><span className="f4 b black">{translate( "SummeOhneSteuer" )}</span></td>
								<td className="f4 b black tr"><Price>{shop.cart.sum}</Price></td>
							</tr> */}


							{/* DISCOUNTS!*/}
							{(shop.session.handId && !!shop.cart.sumDiscount) &&
							<React.Fragment>
								<tr className={"black-60 f5"}>
									<td>{translate( "Discount" )}</td>
									<td className="tr"><Price>{shop.cart.sumDiscount}</Price></td>
								</tr>

								<tr>
									<td><strong>{translate( "nach Rabatt" )}</strong></td>
									<td className="tr"><Price>{shop.cart.sum - shop.cart.sumDiscount}</Price></td>
								</tr>
							</React.Fragment>
							}

							</thead>
							<tbody>
							{hasTax && <tr>
								<td><span className="f5  ">{translate( "zzgl. Steuern" )} ({shop.config.taxRate.replace( ".", "," )}%)</span></td>
								<td className="f5   tr"><Price>{tax}</Price></td>
							</tr>}

							{hasTax && <tr>
								<td><span className="f5 b black">{translate( "inkl. Steuern" )}</span></td>
								<td className="f5 b  tr"><Price>{tax + shop.cart.sum}</Price></td>
							</tr>}
							</tbody>
						</Table>
					</section>
					{/*<section>*/}
					{/*	<div className="mv3">*/}
					{/*		<WordPressContainer*/}
					{/*			className={"ui message mb3"}*/}
					{/*			slug={"confirmation-notice"} postType={"shop"} />*/}
					{/*	</div>*/}
					{/*</section>*/}

					{shop.config.plugin && shop.config.plugin.downloadProductImages && (
						<div className="pv3">
							<p className="f5 fw6 mb2">{translate("Artikelbilder herunterladen")}</p>
							<p className="f6 black-60 mb2">{translate("Laden Sie die Produktbilder aller Artikel im Warenkorb als ZIP-Datei herunter.")}</p>
							<ProductImageDownloader articles={getProducts().map(p => ({ id: p.map_id, title: p.title }))} />
						</div>
					)}

					<FooterCheckout activeStep={2} />

				</div>
			</div>

		)
	}
}

const getProducts = () => shop.cart.map( ( product ) => product )
export default ConfirmationPage



// WEBPACK FOOTER //
// ./src/theme/demo2025/pages/checkout/ConfirmationPage.js